export const apiUrls = {
  login: "v1/auth/admin/login",
  adminslist: "v1/admins",
  adminscreate: "v1/admins",
  adminsupdate: "v1/admins",
  changepassword: "v1/auth/admin/change-password",
  adminsMe: "v1/admins/me",
  updateProfile: "v1/auth/admin/me/updateProfile",
  memberscreate: "v1/admins/add-member",
  memberslist: "v1/admins/getAll-members",
  membersupdate: "v1/admins/update-member",
  membersresetpassword: "v1/admins/reset-member-password",
  enquirieslist: "v1/enquiries",
  membersdelete: "v1/admins/delete-member",
  templateslist: "v1/admins/messages/templates",
  templatescreate: "v1/admins/messages/templates",
  templatesupdate: "v1/admins/messages/templates-update",
  templatesdelete: "v1/admins/messages/templates-delete",
  enquiryReply: "v1/admins/enquiries/reply",
  enquiryListWithoutPagination: 'v1/admins/getall-template',
  adminDashboard: 'v1/admins/dashboard',
  enquiryMarkRead: "v1/enquiries/seen",
  forgotPassword: 'v1/admins/forgot-password',
  verifyResetToken: 'v1/admins/forgot-password/validate',
  resetPassword: 'v1/admins/forgot-password/password',
  verifyResetOtp: 'v1/admins/forgot-password/verify-otp',
  adminsPermanentDeleteMember: 'v1/admins/permanent-delete-member',
  idcardsettings: "v1/admins/id-card-settings",
  idcard: "v1/admins/id-card",
  idcardsprintall: "v1/admins/id-cards/print-all",
  adminsSearchMembers: 'v1/admins/search-members',
  fisherySectionsCreate: "v1/admins/fishery/sections-beats",
  fisherySectionsUpdate: "v1/admins/fishery/sections-beats-update",
  fisherySectionsDelete: "v1/admins/fishery/sections-beats-delete",
  fisherySectionsByRiver: "v1/admins/fishery/rivers-sections-beats",
  fisheryMapsRivers: "v1/admins/fishery/maps-rivers",
  fisheryMapsSection: "v1/admins/fishery/rivers-sections-beats",
  fisheryMapsCreate: "v1/admins/fishery/maps",
  fisheryMapsUpdate: "v1/admins/fishery/maps-update",
  fisheryMapsDelete: "v1/admins/fishery/maps-delete",
  fisheryMapsBySection: "v1/admins/fishery/sections-beats-maps",
  fisheryParkingGet: "v1/admins/fishery/sections-beats/parking",
  fisheryParkingCreate: "v1/admins/fishery/parking",
  fisheryParkingUpdate: "v1/admins/fishery/parking-update",
  fisheryParkingDelete: "v1/admins/fishery/parking-delete",
  fisheryRivers: "v1/admins/fishery/rivers",
  fisheryRiversCreate: "v1/admins/fishery/rivers-add",
  fisheryRiversUpdate: "v1/admins/fishery/rivers-update",
  fisheryRiversDelete: "v1/admins/fishery/rivers-delete",
  catchReturnsGuests: "v1/admins/catch-returns/guests",
  catchReturnsGuestDetail: "v1/admins/fishery/catch-returns/guest-detail",
  catchReturnsGuestDate: "v1/admins/fishery/catch-returns/guest-date",
  catchReturnsExcel: "v1/admins/fishery/catch-returns/export/excel",
  catchReturnsGraph: "v1/admins/fishery/catch-returns/export/graph",
  fishTypes: "v1/admins/fish-types",
  fishTypesCreate: "v1/admins/fish-types/add",
  fishTypesUpdate: "v1/admins/fish-types/update",
  fishTypesDelete: "v1/admins/fish-types/delete",
  adminsCatchReturns: 'v1/admins/catch-returns',
  adminRulesDocuments: "v1/admins/rules/documents",
  adminRulesDocumentsUpdate: "v1/admins/rules/documents-update",
  adminRulesDocumentsDelete: "v1/admins/rules/documents-delete",
  adminRulesDocumentsPermissions: "v1/admins/rules/documents-permissions",
  adminRulesGroups: "v1/admins/rules/groups",
  adminRulesGroupsUpdate: "v1/admins/rules/groups-update",
  adminRulesGroupsDelete: "v1/admins/rules/groups-delete",
  competitionScoreboard: 'v1/admins/seasonal-competitions/scoreboard',
  competitionArchiveYears: 'v1/admins/seasonal-competitions/archive/years',
  competitionVerifyCatch: 'v1/admins/seasonal-competitions/scoreboard/verify',
  adminGetAllFish: 'v1/admins/getall-fish',
  adminsSeasonalCompetitions: 'v1/admins/seasonal-competitions/add-competition',
  adminsSeasonalCompetitionsCreateOrUpdate: 'v1/admins/seasonal-competitions/create-or-update',
  adminsSeasonalCompetitionById: 'v1/admins/seasonal-competitions',
  annualCompetitions: "v1/admins/annual-competitions",
  annualCompetitionsCreateOrUpdate: "v1/admins/annual-competitions/create-or-update",
  annualInvitesCreate: "v1/admins/annual-competitions/create/invites",
  annualInvitesReplies: "v1/admins/annual-competitions/invites/replies",
  annualInviteReplyGet: "v1/admins/annual-competitions/get/invites/reply",
  annualInviteReplyUpdate: "v1/admins/annual-competitions/update/invites",
  annualInvitesSend: 'v1/admins/annual-competitions/invites/send',
  annualTrophiesList: "v1/admins/annual-competitions/all/trophies",
  annualTrophiesCreate: "v1/admins/annual-competitions/trophies",
  annualTrophiesUpdate: "v1/admins/annual-competitions/trophies/update",
  annualTrophiesDelete: "v1/admins/annual-competitions/delete/trophies",
  annualCompetitionResults: "v1/admins/annual-competitions/results",
  annualCompetitionNoWinners: "v1/admins/annual-competitions/results/no-winners",
  annualTrophyWinner: "v1/admins/annual-competitions/results/trophy-winner",
  annualTrophyWinnerList: "v1/admins/annual-competitions/results/trophy-winner",
  annualCatchReturns: "v1/admins/annual-competitions/results/catch-returns",
  annualCompetitionArchive: "v1/admins/annual-competitions/archive",
  annualCurrentTrophyHolders: "v1/admins/annual-competitions/results/current-trophy-holders",
  dinnersEventsList: "v1/admins/dinners-events",
  dinnersEventsAdd: "v1/admins/dinners-events/add",
  dinnersEventsUpdate: "v1/admins/dinners-events/update",
  dinnersEventsDelete: "v1/admins/dinners-events/delete",
  dinnersEventsInviteCreate: "v1/admins/dinners-events/invites/create",
  dinnersEventsInviteSend: "v1/admins/dinners-events/invites/send",
  dinnersEventsInviteReply: "v1/admins/dinners-events/invites",
  archiveDirectories: "v1/admins/club-archive/directories",
  archiveDirectoriesUpdate: "v1/admins/club-archive/directories/update",
  archiveDirectoriesDelete: "v1/admins/club-archive/directories/delete",
  archiveDocuments: "v1/admins/club-archive/documents",
  archiveDocumentsUpdate: "v1/admins/club-archive/documents/update",
  archiveDocumentsDelete: "v1/admins/club-archive/documents/delete",
  archiveDocumentsPermissions: "v1/admins/club-archive/documents/permissions",
  adminGetAllGroup: "v1/admins/getall-groups",
  newsletterList: "v1/admins/newsletter/templates",
  newsletterAction: "v1/admins/newsletter/action",
  newsletterArchive: "v1/admins/newsletter/archive",
  quickMessageSend: "v1/admins/messages/send",
  adminIncidentReport: "v1/admins/incidents/reports",
  adminIncidentReportView: "v1/admins/incidents/reports-view",
  adminMessageList: "v1/admins/messages/member",
  adminMessageView: "v1/admins/messages/member/view",
  adminMemberMessages: "v1/admins/messages/member",
  adminMemberMessageRead: "v1/admins/messages/member/view",
  adminGetAllMembers: "v1/admins/get-all-members",
  adminMessages: "v1/admins/messages",
  adminRulesDocumentsGroupsAll: "v1/admins/rules/documents/groups-all",

  notificationsDevices: "v1/notifications/devices",




  memberLogin: 'v1/auth/member/login',
  otpVerification: "v1/member/otp-verification",
  agreeCheckbox: "v1/member/agree-checkbox",
  memberEnquries: "v1/enquiries",
  memberFisheryRiversList: "v1/member/maps-rivers",
  memberSectionListByRiver: "v1/member/rivers-sections-beats",
  memberCatchReturnSubmit: 'v1/member/catch-return-submit',
  fishTypesList: "v1/member/all-fish",
  sectionsBeatsMaps: "v1/member/sections-beats-maps",
  incidentReportSubmit: "v1/member/reports-create",
  rulesRegulationsDocuments: "v1/member/rules-regulations/documents",
  getInvitation: "v1/member/get-invitation",
  respondInvitation: "v1/member/invites/respond",
  vehicleCheck: "v1/member/vehicle-check",
  checkMemberInfo: "v1/member/check-member-info",
  memberNamesList: 'v1/member/all-member',
  memberNotification: 'v1/member/notifications',
  memberNotificationView: 'v1/member/notifications/view',
  sendMessageToAdmin: "v1/member/messages/admin",
  getTermsAndConditions: "v1/admins/tc/terms-and-conditions",
  createTermsAndConditions: "v1/admins/tc/terms-and-conditions",
  updateTermsAndConditions: "v1/admins/tc/terms-and-conditions-update",
  deleteTermsAndConditions: "v1/admins/tc/terms-and-conditions-delete",
  setCurrentTermsAndConditions: "v1/admins/tc/terms-and-conditions-set-current",
  getCurrentTermsAndConditions: "v1/member/terms-and-conditions/current"
};
